module.exports = __webpack_public_path__ + "img/icon_beauty&wellbeing_greyed.32ef19cc.png";